module.exports = __webpack_public_path__ + "img/user.a0c4ee77.png";